import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
import { GetShapeBySku } from "../../product/queries/getShapeBySku.catalogue.js";
import GetOrder from "../queries/GetOrder.pim.js";
export const getOrder = async ({ orderId }, { client }) => {
    const data = await client.pim.request(GetOrder, { orderId });
    if (!data.order.get)
        throw new Error(`No order found for orderId: ${orderId}`);
    return data.order.get;
};
export const getOrderItemsByType = async (order, { client }) => {
    const data = await client.catalogue.request(GetShapeBySku, {
        skus: order.cart.reduce((acc, { sku }) => (sku ? [...acc, sku] : acc), []),
    });
    return data.productVariants.reduce((acc, variant) => {
        const orderItem = order.cart.find((orderItem) => orderItem.sku === variant?.sku);
        if (!orderItem || !variant?.product?.shapeIdentifier)
            return acc;
        const orderItemWithOriginalPrice = {
            ...orderItem,
            originalPrice: variant.price,
        };
        switch (variant.product.shapeIdentifier) {
            case CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK.ID:
                return { ...acc, books: [...acc.books, orderItemWithOriginalPrice] };
            case CRYSTALLIZE_IDS.SHAPE.PRODUCT.SERIES_SUBSCRIPTION.ID:
            case CRYSTALLIZE_IDS.SHAPE.PRODUCT.SUBSCRIPTION.ID:
            case CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB.ID:
                return {
                    ...acc,
                    subscription: [...acc.subscription, orderItemWithOriginalPrice],
                };
            case CRYSTALLIZE_IDS.SHAPE.PRODUCT.FREIGHT.ID:
                return {
                    ...acc,
                    freight: [...acc.freight, orderItemWithOriginalPrice],
                };
            case CRYSTALLIZE_IDS.SHAPE.PRODUCT.NOT_BOOK.ID:
                return { ...acc, gifts: [...acc.gifts, orderItemWithOriginalPrice] };
            default:
                return {
                    ...acc,
                    others: [...acc.others, orderItemWithOriginalPrice],
                };
        }
    }, {
        books: [],
        freight: [],
        subscription: [],
        gifts: [],
        others: [],
    });
};
